import React, { useEffect, useState } from 'react';
import { Printer } from 'lucide-react';
import Filters from './Filters';
import OverviewTab from './OverviewTab';
import UsersTab from './UsersTab';
import ProjectsTab from './ProjectsTab';
import TasksTab from './TasksTab';
import { Button, PageHeader, Tabs } from '../../components/ui';

const EMPTY_FILTERS = {
    startDate: '',
    endDate: '',
    status: '',
    priority: '',
    search: '',
    projectId: '',
    assigneeId: '',
    isOverdue: false,
};

const TABS = [
    { value: 'overview', label: 'System overview' },
    { value: 'users', label: 'User performance' },
    { value: 'projects', label: 'Project status' },
    { value: 'tasks', label: 'Task analysis' },
];

const Reports = () => {
    const [activeTab, setActiveTab] = useState('overview');
    const [activeFilters, setActiveFilters] = useState(EMPTY_FILTERS);
    const [appliedFilters, setAppliedFilters] = useState(EMPTY_FILTERS);

    useEffect(() => {
        document.title = 'Reports & Analytics | MyBank ICT';
    }, []);

    const handleApplyFilters = () => setAppliedFilters(activeFilters);

    const handleResetFilters = () => {
        setActiveFilters(EMPTY_FILTERS);
        setAppliedFilters(EMPTY_FILTERS);
    };

    const renderTabContent = () => {
        switch (activeTab) {
            case 'users':
                return <UsersTab filters={appliedFilters} />;
            case 'projects':
                return <ProjectsTab filters={appliedFilters} />;
            case 'tasks':
                return <TasksTab filters={appliedFilters} />;
            default:
                return <OverviewTab filters={appliedFilters} />;
        }
    };

    return (
        <>
            <PageHeader
                title="Reports & Analytics"
                description="Delivery, workload and performance across the selected period."
                breadcrumbs={[{ label: 'Home', to: '/' }, { label: 'Reports' }]}
                actions={
                    <Button icon={Printer} className="no-print" onClick={() => window.print()}>
                        Print report
                    </Button>
                }
            />

            <Tabs tabs={TABS} value={activeTab} onChange={setActiveTab} className="mb-4 no-print" />

            <Filters
                filters={activeFilters}
                onChange={setActiveFilters}
                onReset={handleResetFilters}
                onApply={handleApplyFilters}
            />

            <div className="mt-4 min-h-[400px]">{renderTabContent()}</div>
        </>
    );
};

export default Reports;
